import { render, staticRenderFns } from "./mini-code.vue?vue&type=template&id=21b2af73&scoped=true&"
import script from "./mini-code.vue?vue&type=script&lang=js&"
export * from "./mini-code.vue?vue&type=script&lang=js&"
import style0 from "./mini-code.vue?vue&type=style&index=0&id=21b2af73&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b2af73",
  null
  
)

export default component.exports